export default "__VITE_ASSET__DKF7BdNj__"